/**
 * @exports
 * @class ProductsSplit
 */
import { get, getAll } from '../../helpers/utilities';

export class ProductsSplit {
    public static selector = '.js-products-split';
    private root: Element;


    /**
     * Initialises a new instance of ProductsSplit
     *
     * @param root The root element for this block
     */
    constructor(root: Element) {
        this.root  = root;

        this.bindEvents();
    }


    /**
     * Binds the events for this class
     * 
     * @private
     * @returns void
     */
    public bindEvents(): void {

        // Slide them in once visible
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0.25) {
                    this.root.classList.add('c-products-split--is-visible');
                }
            });
        }, { threshold: [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1] });
        observer.observe(this.root);

        // When hovering over the link, set the max height of the content so it can animate
        const links = getAll('.js-product-split__link') as HTMLAnchorElement[];
        if(links) {
            links.forEach(link => {
                
                // Add max height
                link.addEventListener('mouseenter', () => {
                    this.addMaxHeight(link);
                });
                
                // Remove max height
                link.addEventListener('mouseleave', () => {
                    this.removeMaxHeight(link);
                });
            });
        }
    }


    /**
     * Add's a max height to our content for this link, so it can be animated open.
     *
     * @param link The link to animate the content for
     */
    private addMaxHeight(link: HTMLAnchorElement) {
        const textContainer = get('.js-product-split__desc', link) as HTMLElement;
        const text          = get('.js-product-split__link__content', link) as HTMLElement;
        if(textContainer && text) {
            const height = text.offsetHeight;
            textContainer.style.maxHeight = `${height}px`;
        }
    }


    /**
     * Removes the max height from our content for this link, so it can be animated closed.
     *
     * @param link The link to animate the content for
     */
    private removeMaxHeight(link: HTMLAnchorElement) {
        const textContainer = get('.js-product-split__desc', link) as HTMLElement;
        if(textContainer) {
            textContainer.style.maxHeight = `0px`;
        }
    }
}
